<template>
  <div class="strategies-typeahead">
    <input
      :disabled="fetching"
      type="text"
      class="form-control"
      ref="input"
      v-model="searchStr"
      :id="id"
      placeholder="Strategy name">
    <typeahead
      v-model="selected"
      :target="target"
      :data="strategies"
      item-key="title"
      force-select
    />
  </div>
</template>

<script>
import { getStrategies } from '@/api/strategies'
import { Typeahead, Notification } from 'uiv'

export default {
  name: 'SelectStrategyTypeahead',
  components: { Typeahead },
  props: {
    id: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      fetching: false,
      searchStr: '',
      strategies: [],
      target: null,
      selected: null
    }
  },
  methods: {
    async getStrategies() {
      this.fetching = true
      try {
        let resp = await getStrategies({
          published: true,
          size: 400,
          fields: 'uuid,title,image_url'
        })
        this.strategies = resp.hits.hits.map(hit => {
          return hit._source
        })
        this.fetching = false
      } catch (err) {
        Notification.notify.error({
          duration: 0,
          offsetY: 65,
          title: 'Error fetching strategies for autocompletion',
          content: err
        })
      }
    },
    optionSelected(strategy) {
      this.$emit('selected', strategy)
      this.selected = null
      this.searchStr = ''
    }
  },
  watch: {
    selected() {
      if (this.selected && this.selected.uuid) {
        this.optionSelected(this.selected)
      }
    }
  },
  mounted() {
    this.target = this.$refs.input
    this.getStrategies()
  }
}
</script>

<style scoped>
.strategies-typeahead {
  margin-bottom: 1em;
}
</style>
